import { Typography } from '@mui/material'

import { ModalWrapper, DeleteConfirmForm, HelperWrapper } from 'src/components'
import { EAccountSubscriptionPlans, IAccountByIdRespDto } from 'src/types'

import { useStyles } from './styles'

interface IDeleteConfirmModalProps {
  isUserProfile?: boolean
  open: boolean
  handleClose: () => void
  handleDelete: () => void | Promise<void>
  account: IAccountByIdRespDto | null
}

const DeleteConfirmModal = ({
  open,
  handleClose,
  handleDelete,
  account,
}: IDeleteConfirmModalProps) => {
  const classes = useStyles()

  const handleSubmit = async () => {
    await handleDelete()
  }

  const hasActiveSubscription =
    account?.subscription_plan !== EAccountSubscriptionPlans.free &&
    account?.subscription_cancelled === false

  return (
    <ModalWrapper className={classes.formWrapper} onClose={handleClose} open={open}>
      <div className={classes.sectionWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="close-account-button-text" />
        </Typography>
        {hasActiveSubscription ? (
          <Typography className={classes.text}>
            <HelperWrapper t="close-account-subscription-warning" />
            <br /> <br />
            <b>
              <HelperWrapper t="close-account-subscription-warning-1" />
            </b>
          </Typography>
        ) : (
          <Typography className={classes.text}>
            <HelperWrapper t="close-account-main-warning" />
            <br />
            &nbsp;
            <b>
              <HelperWrapper t="close-account-main-warning-1" />
            </b>
          </Typography>
        )}
      </div>

      <DeleteConfirmForm disabled={hasActiveSubscription} handleSubmit={handleSubmit} />
    </ModalWrapper>
  )
}

export { DeleteConfirmModal }
